import Black from '@/assets/pyramidbet/fonts/Roboto-Black.ttf';
import BlackItalic from '@/assets/pyramidbet/fonts/Roboto-BlackItalic.ttf';
import Bold from '@/assets/pyramidbet/fonts/Roboto-Bold.ttf';
import BoldItalic from '@/assets/pyramidbet/fonts/Roboto-BoldItalic.ttf';
import ExtraLight from '@/assets/pyramidbet/fonts/Roboto-Thin.ttf';
import ExtraLightItalic from '@/assets/pyramidbet/fonts/Roboto-ThinItalic.ttf';
import Light from '@/assets/pyramidbet/fonts/Roboto-Light.ttf';
import LightItalic from '@/assets/pyramidbet/fonts/Roboto-LightItalic.ttf';
import Regular from '@/assets/pyramidbet/fonts/Roboto-Regular.ttf';
import Italic from '@/assets/pyramidbet/fonts/Roboto-Italic.ttf';
import SemiBold from '@/assets/pyramidbet/fonts/Roboto-Medium.ttf';
import SemiBoldItalic from '@/assets/pyramidbet/fonts/Roboto-MediumItalic.ttf';
import ThothLegacy from '@/assets/pyramidbet/fonts/ThothLegacy-Regular.ttf';
import PoppinsBlack from '@/assets/pyramidbet/fonts/Poppins-Black.ttf';
import PoppinsBold from '@/assets/pyramidbet/fonts/Poppins-Bold.ttf';
import PoppinsExtraBold from '@/assets/pyramidbet/fonts/Poppins-ExtraBold.ttf';
import PoppinsExtraLight from '@/assets/pyramidbet/fonts/Poppins-ExtraLight.ttf';
import PoppinsLight from '@/assets/pyramidbet/fonts/Poppins-Light.ttf';
import PoppinsMedium from '@/assets/pyramidbet/fonts/Poppins-Medium.ttf';
import PoppinsRegular from '@/assets/pyramidbet/fonts/Poppins-Regular.ttf';
import PoppinsSemiBold from '@/assets/pyramidbet/fonts/Poppins-SemiBold.ttf';
import PoppinsThin from '@/assets/pyramidbet/fonts/Poppins-Thin.ttf';

export const fontFace = `
        @font-face {
          font-family: 'ThothLegacy';
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: url('${ThothLegacy}') format('opentype');
        }
        @font-face {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 100;
          font-display: swap;
          src: url('${PoppinsThin}') format('opentype');
        }
        @font-face {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 600;
          font-display: swap;
          src: url('${PoppinsSemiBold}') format('opentype');
        }
        @font-face {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: url('${PoppinsRegular}') format('opentype');
        }
        @font-face {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 500;
          font-display: swap;
          src: url('${PoppinsMedium}') format('opentype');
        }
        @font-face {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 300;
          font-display: swap;
          src: url('${PoppinsLight}') format('opentype');
        }
        @font-face {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 200;
          font-display: swap;
          src: url('${PoppinsExtraLight}') format('opentype');
        }
        @font-face {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 800;
          font-display: swap;
          src: url('${PoppinsExtraBold}') format('opentype');
        }
        @font-face {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 700;
          font-display: swap;
          src: url('${PoppinsBold}') format('opentype');
        }
        @font-face {
          font-family: 'Poppins';
          font-style: normal;
          font-weight: 900;
          font-display: swap;
          src: url('${PoppinsBlack}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 100;
          font-display: swap;
          src: url('${ExtraLight}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 100;
          font-display: swap;
          src: url('${ExtraLightItalic}') format('opentype');
        }
      
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 300;
          font-display: swap;
          src: url('${Light}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 300;
          font-display: swap;
          src: url('${LightItalic}') format('opentype');
        }
      
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: url('${Regular}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 400;
          font-display: swap;
          src: url('${Italic}') format('opentype');
        }
      
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 500;
          font-display: swap;
          src: url('${SemiBold}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 500;
          font-display: swap;
          src: url('${SemiBoldItalic}') format('opentype');
        }
      
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 700;
          font-display: swap;
          src: url('${Bold}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 700;
          font-display: swap;
          src: url('${BoldItalic}') format('opentype');
        }
      
        @font-face {
          font-family: 'roboto';
          font-style: normal;
          font-weight: 900;
          font-display: swap;
          src: url('${Black}') format('opentype');
        }
        @font-face {
          font-family: 'roboto';
          font-style: italic;
          font-weight: 900;
          font-display: swap;
          src: url('${BlackItalic}') format('opentype');
        }
      `;
